import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  MULTIPLE_SUCCESS: `${cleanedFilename(__filename)}-multiple-success`,
  IMPORT_MORE_BUTTON: `${cleanedFilename(__filename)}-import-more-button`,
  CLOSE_BUTTON: `${cleanedFilename(__filename)}-close-button`,
};
